module.exports = __webpack_public_path__ + "static/leruban-spinner-162ae2c5dce7237317134a155053af4d.png";